import { ElementType, ReactNode } from 'react';
import styled from 'styled-components';
import {
  FontFamilyProps,
  FontWeightProps,
  LetterSpacingProps,
  LineHeightProps,
  TextAlignProps,
  fontFamily,
  fontWeight,
  letterSpacing,
  lineHeight,
  textAlign,
} from 'styled-system';
import { BaseStyleProps, base, themed } from '../base';

export interface HeadingProps
  extends BaseStyleProps,
    FontFamilyProps,
    FontWeightProps,
    TextAlignProps,
    LineHeightProps,
    LetterSpacingProps {
  as?: ElementType;
  content?: ReactNode;
  className?: string;
  id?: string;
  style?: React.CSSProperties;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const HeadingWrapper = styled('p')<HeadingProps>(
  base as any,
  fontFamily as any,
  fontWeight as any,
  textAlign as any,
  lineHeight as any,
  letterSpacing as any,
  themed('Heading') as any
);
/* eslint-enable @typescript-eslint/no-explicit-any */

const Heading = ({
  as = 'h2',
  mt = 0,
  mb = '1rem',
  fontWeight = 'bold',
  content,
  ...props
}: HeadingProps) => (
  <HeadingWrapper as={as} mt={mt} mb={mb} fontWeight={fontWeight} {...props}>
    {content}
  </HeadingWrapper>
);

export default Heading;
